import type { GetState, ThunkDispatchType } from 'app/redux/types';

import type { BettingEntitiesSelectors } from 'app/lib/betting/betting-entities';

import { createImmutableObjects, createMatchEntity } from '../utils/entries';
import { InsertInQueueForAdd, insertInQueueForAdd } from './entries';

// ---

export type AddBetAction = (
  matchId: number,
  betId: number,
) => (dispatch: ThunkDispatchType<InsertInQueueForAdd>, getState: GetState) => void;

export type AddBetFactoryAction = (
  matchesSelector: BettingEntitiesSelectors['matches'],
  sportsSelector: BettingEntitiesSelectors['sports'],
  objectsSelector: BettingEntitiesSelectors['objects'],
) => AddBetAction;

export const addBetFactory: AddBetFactoryAction = (
  matchesSelector,
  sportsSelector,
  objectsSelector,
) => (
  (matchId, betId) => (
    dispatch,
    getState,
  ): void => {
    const state = getState();

    const objects = objectsSelector(state);
    const match = matchesSelector(state).get(matchId);

    const bet = match && match.bets.get(betId);
    const stake = match && bet && match.stakes.get(bet.stakeId);

    const sport = match && sportsSelector(state).get(match?.sportId);

    if (match && bet && stake && sport) {
      const matchObjects = createImmutableObjects(match, objects);

      const entity = createMatchEntity(match, matchObjects);

      dispatch(insertInQueueForAdd({
        bet,
        stake,
        sport,
        match: entity,
      }));
    }
  }
);
